var _rect, _rect2, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeditech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 60",
    role: "img",
    "aria-label": "Meditech",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 238,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 20,
    height: 20,
    fill: "#0f7ab3",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 36 L22 24 L28 32 L34 24 L34 36",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 38,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#0f7ab3",
    letterSpacing: -0.3
  }, "MEDITECH")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditech);
export default __webpack_public_path__ + "static/media/meditech.caac01288f72ab01f549b4b2387c8a29.svg";
export { ForwardRef as ReactComponent };